import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { PlanService } from "../../../../services/plan.service";

@Component({
  selector: "page-reservation-confirm",
  templateUrl: "./index.component.html",
})
export class PageReservationConfirmComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any = {};
  public passengerChangeData: any = {};
  public activatedStation: any = {};
  public currentCancelRuleItem: any = {};
  public divisionData: any = {};
  public cancelInformation: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public planService: PlanService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();
  }

  async ngOnInit() {
    /* COMMENTED FOR PUBLIC SEARCH CHECK IF NOT LOGGED IN */
    /* if (!this.authService.isLoggedIn()) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHomeNoParam);
        } */

    /* CHECK IF SUBMITTED FROM CHANGING PAGE, IF NOT REDIRECT TO CHANGING PAGE */
    if (!this.commonService.getNRemoveData("onSubmitReservationChanging")) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationChangeNoParam,
        [this.activatedRoute.snapshot.paramMap.get("reservationID")]
      );
    }

    /* SET PAGE TITLE */
    this.commonService.setTitle(`予約を確認する | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let reservationData = this.reservationService.getReservationChangesData();
    if (this._.isEmpty(reservationData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }

    /* GET DIVISION DATA */
    this.divisionData = await this.planService.getDivisions();

    /* GET RESERVATION DATA */
    this.reservationData = reservationData.reservationData;
    this.passengerChangeData = reservationData.passengerChangeData;

    /* SET CURRENT ITEM & LAST ITEM OF CANCEL LIST */
    let firstItem = this.reservationData.reservation.bus_detail.cancel_list[0];
    if (firstItem && firstItem.price) {
      this.currentCancelRuleItem = {
        ...firstItem,
        rate: `${firstItem.price}円`,
      };
    } else {
      this.currentCancelRuleItem = { id: 0, name: "無し", rate: 0 };
    }

    for (let [
      index,
      item,
    ] of this.reservationData.reservation.bus_detail.cancel_list.entries()) {
      if (
        index <
          this.reservationData.reservation.bus_detail.cancel_list.length - 1 &&
        !item.price
      ) {
        if (
          (this.reservationData.reservation.dayBeforeDepartureDay <=
            item.from &&
            this.reservationData.reservation.dayBeforeDepartureDay >=
              item.to) ||
          (item.from == 0 &&
            item.to == 0 &&
            this.reservationData.reservation.dayBeforeDepartureDay == 0)
        ) {
          this.currentCancelRuleItem = item;
          break;
        }
      }
    }
    /* CHECK LAST */
    if (
      this.reservationData.reservation.cancelList.lastItem.from == 0 &&
      this.reservationData.reservation.cancelList.lastItem.to == 0 &&
      this.reservationData.reservation.dayBeforeDepartureDay < 0
    ) {
      this.currentCancelRuleItem =
        this.reservationData.reservation.cancelList.lastItem;
    }

    /* GET CANCEL INFORMATION */
    await this.getCancelInformation();
    /* END */

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async submitChanges() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("処理中・・・");

    /* REMOVE LAST ERROR MESSAGES */
    delete this.tempData.changeErrorMessage;

    let changeData = this.reservationService.makeReservationChangeData(
      this.reservationData,
      this.passengerChangeData
    );

    let returnedData: any = await this.reservationService.changeReservation(
      changeData
    );

    if (returnedData.status == "success") {
      /* CLEAR TEMP CACHES */
      this.commonService.removeData(
        this.commonService.appConfig.reservation
          .changeReservationDataSessionName
      );
      this.commonService.removeData("onSubmitReservationChanging");

      /* SHOW FINISH MODAL */
      this.$("#mdl-change-finish").modal();
    } else {
      /* GET ERROR MESSAGE */
      let message = [];
      if (Array.isArray(returnedData.data)) {
        for (let item of returnedData.data) {
          for (let key in item) {
            message.push(item[key]);
          }
        }
      } else if (this._.isObject(returnedData.data)) {
        for (let key in returnedData.data) {
          message.push(returnedData.data[key]);
        }
      } else {
        message.push(returnedData.data);
      }
      message.push(`ご情報をご確認ください。`);
      this.tempData.changeErrorMessage = message.join("<br>");
      /* END */
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async cancelFinishModal() {
    /* CHECK IF IT IS FROM PUBLIC SEARCH */
    let reservationData = this.commonService.getData(
      "searchReservationDataDetail"
    );
    if (!this._.isEmpty(reservationData)) {
      /* SHOW PAGE LOADER */
      this.commonService.showPageLoader("処理中・・・");

      /* GET RESERVATION DATA */
      let reservationData: any =
        await this.reservationService.findReservationByID(
          this.commonService.getData("searchReservationParams")
        );

      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();

      if (!this._.isEmpty(reservationData.reservation)) {
        this.commonService.closeAllModals();
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReservationDetailNoParam,
          [this.reservationData.reservation.reservation_id]
        );
      } else {
        /* CLEAR ALL CACHES */
        this.commonService.removeData("searchReservationParams");
        this.commonService.removeData("searchReservationDataEmail");
        this.commonService.removeData("searchReservationDataEmail");

        this.commonService.closeAllModals();
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageHomeNoParam
        );
      }
    } else {
      this.commonService.closeAllModals();
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationDetailNoParam,
        [this.reservationData.reservation.reservation_id]
      );
    }
  }

  async getCancelInformation() {
    let boardUser = "";
    for (
      let i = 0;
      i < this.reservationData.reservation.passenger_list.length;
      i++
    ) {
      boardUser += `${this.passengerChangeData["p_board_" + (i + 1)]}|`;
    }
    boardUser = boardUser.substr(0, boardUser.length - 1);

    let postCancelInformationData = {
      cancel_type: this.currentCancelRuleItem.id,
      reservation_id: this.reservationData.reservation.reservation_id,
      change_board: boardUser,
      auth_token: this.reservationData.reservation.auth_token,
    };
    this.cancelInformation = await this.reservationService.getCancelInformation(
      postCancelInformationData
    );
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  inlineJS() {
    let self = this;
  }
}
